import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M8.31688 15L12.1022 11.12L15.8876 15C16.0699 15.1872 16.3173 15.2925 16.5754 15.2925C16.8335 15.2925 17.0809 15.1872 17.2632 15C17.6437 14.61 17.6437 13.98 17.2632 13.59L12.7852 8.99999C12.4047 8.60999 11.79 8.60999 11.4096 8.99999L6.93151 13.59C6.55102 13.98 6.55102 14.61 6.93151 15C7.312 15.38 7.93639 15.39 8.31688 15Z";

export default function UpChevron(props: IconProps) {
  return <SVGIcon path={path} {...props} />;
}
